<template>
  <Select v-model="chgoptions" class="left btnarea" style="width:120px;">
    <Option :value="0">全部</Option>
    <OptionGroup label="====================" v-for="(it, i) in select2" :key="i">
      <Option
        class="bold"
        v-for="item in it"
        :class="item.thame"
        :value="item.value"
        :key="item.value"
      >{{ i > 0 ? getliveshow.title : '' }} {{ item.label }}</Option>
    </OptionGroup>
  </Select>
</template>
<script>
import selectAllupch from "./SelectAllupch";
import { mapGetters } from 'vuex';
export default {
  mixins: [selectAllupch],
  computed: {
    ...mapGetters(['getliveshow']),
    selectTitle () {
      return this.getliveshow.title
    },
    select2 () {
      const object = {
        0: [
          { thame: "pr", value: 1, label: "紅波" },
          { thame: "pb", value: 2, label: "藍波" },
          { thame: "pg", value: 3, label: "綠波" }
        ],
        1: [
          { thame: "", value: 4, label: "合单" },
          { thame: "", value: 5, label: "合单" }
        ],
        2: [
          { thame: "", value: 6, label: "尾大" },
          { thame: "", value: 7, label: "尾小" }
        ],
        3: [
          { thame: "", value: 8, label: "单" },
          { thame: "", value: 9, label: "双" },
          { thame: "", value: 10, label: "大" },
          { thame: "", value: 11, label: "小" }
        ],
        4: [
          { thame: "pr", value: 12, label: "紅單" },
          { thame: "pr", value: 13, label: "紅雙" },
          { thame: "pr", value: 14, label: "紅大" },
          { thame: "pr", value: 15, label: "紅小" }
        ],
        5: [
          { thame: "pb", value: 16, label: "藍單" },
          { thame: "pb", value: 17, label: "藍雙" },
          { thame: "pb", value: 18, label: "藍大" },
          { thame: "pb", value: 19, label: "藍小" }
        ],
        6: [
          { thame: "pg", value: 20, label: "綠單" },
          { thame: "pg", value: 21, label: "綠雙" },
          { thame: "pg", value: 22, label: "綠大" },
          { thame: "pg", value: 23, label: "綠小" }
        ],
        7: [
          { thame: "pgray", value: 24, label: "鼠" },
          { thame: "pgray", value: 25, label: "牛" },
          { thame: "pgray", value: 26, label: "虎" },
          { thame: "pgray", value: 27, label: "兔" },
          { thame: "pgray", value: 28, label: "龍" },
          { thame: "pgray", value: 29, label: "蛇" },
          { thame: "pgray", value: 30, label: "馬" },
          { thame: "pgray", value: 31, label: "羊" },
          { thame: "pgray", value: 32, label: "猴" },
          { thame: "pgray", value: 33, label: "雞" },
          { thame: "pgray", value: 34, label: "狗" },
          { thame: "pgray", value: 35, label: "豬" }
        ]
      }
      return object
    }
  },
  watch: {
    '$route' (to, from) {
      this.upDate_oddItemSelect({ option: 0 });
    }
  },
  mounted () {
    this.upDate_oddItemSelect({ option: 0 });
  },
};
</script>